module.exports = vendor_eddc80ba85656bd535d6;